module.exports = __webpack_public_path__ + "img/04-B04.1bf393fd.png";